(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["admin-editable-article"] && !Shopify.designMode) return;
  try {
    (() => {
  const observed = new WeakSet();
  const initialise = () => {
    document.querySelectorAll(".guide-sidebar-inner").forEach(sidebar => {
      if (observed.has(sidebar)) return;
      observed.add(sidebar);
      const measure = () => {
        const height = Math.ceil(sidebar.getBoundingClientRect().height) + "px";
        if (sidebar.style.getPropertyValue("--guide-sidebar-height") !== height) {
          sidebar.style.setProperty("--guide-sidebar-height", height);
        }
      };
      measure();
      if ("ResizeObserver" in window) new ResizeObserver(measure).observe(sidebar);
      else window.addEventListener("resize", measure, { passive: true });
    });
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initialise, { once: true });
  else initialise();
  document.addEventListener("shopify:section:load", initialise);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["electric-shared-footer"] && !Shopify.designMode) return;
  try {
    (function(){var footer=document.getElementById('ct-site-footer');if(!footer)return;var details=footer.querySelector('#ct-footer-callback');var firstField=footer.querySelector('#ct-callback-name');function openCallback(focus){details.open=true;if(focus&&firstField)firstField.focus({preventScroll:true})}footer.querySelectorAll('[data-ct-callback-link]').forEach(function(link){link.addEventListener('click',function(){openCallback(true)})});if(location.hash==='#ct-footer-callback')openCallback(false);var status=footer.querySelector('.ct-footer-success,.ct-footer-errors');if(status){openCallback(false);status.focus()}var narrow=window.matchMedia('(max-width:700px)');function sync(){footer.querySelectorAll('.ct-footer-nav').forEach(function(item){item.open=!narrow.matches})}sync();narrow.addEventListener('change',sync)})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pilot-chatway-loader"] && !Shopify.designMode) return;
  try {
    (function(){var widget=document.getElementById('coventry-whatsapp-widget');if(!widget)return;var summary=widget.querySelector('summary');widget.querySelector('.coventry-whatsapp-close').addEventListener('click',function(){widget.open=false;summary.focus()});document.addEventListener('keydown',function(event){if(event.key==='Escape'&&widget.open){widget.open=false;summary.focus()}});document.addEventListener('click',function(event){if(widget.open&&!widget.contains(event.target))widget.open=false})})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pilot-collection-filter"] && !Shopify.designMode) return;
  try {
    (() => {
  function init() {
    const root=document.getElementById('pf-pilot');
    if(!root||root.dataset.ready)return;
    const data=JSON.parse(root.querySelector('#pf-data').textContent);
    const holder=document.querySelector('.products.woodmart-products-holder');
    if(!holder)return;
    const cards=Array.from(holder.children).filter(el=>el.querySelector('.product-title a'));
    const products=cards.map(card=>{const link=card.querySelector('.product-title a');const handle=new URL(link.href).pathname.split('/products/')[1]?.split('/')[0];return {card, facts:data.products.find(p=>p.handle===handle)};});
    if(products.length!==data.products.length||products.some(p=>!p.facts||!p.facts.height))return;
    root.dataset.ready='true';holder.classList.add('pf-products');root.hidden=false;
    const order={availability:['in','out'],model:['straight','curved'],finish:['chrome','black'],btu:['under1000','1000to1500','1500to2000','2000to2500','2500to3000','over3000']};
    root.querySelectorAll('details[data-group]').forEach(d=>{
      const group=d.dataset.group;
      const values=order[group]?order[group].filter(v=>group==='availability'||data.products.some(p=>p[group]===v)):Array.from(new Set(data.products.map(p=>p[group]))).sort((a,b)=>Number(a)-Number(b));
      values.forEach(value=>{
        const label=document.createElement('label'),input=document.createElement('input'),span=document.createElement('span'),count=document.createElement('small');
        const text=group==='width'||group==='height'?data.mmText.replace('__value__',value):data.labels[value];
        input.type='checkbox';input.dataset.group=group;input.value=value;input.setAttribute('aria-label',text);span.textContent=text;count.className='pf-count';label.append(input,span,count);d.querySelector('.pf-menu').append(label);
      });
    });
    const inputs=Array.from(root.querySelectorAll('input[data-group]'));
    const more=document.querySelector('.pf-more');
    const pageSize=Math.max(1,Number(root.dataset.pageSize)||products.length);
    let visibleLimit=pageSize;
    const groups=Array.from(new Set(inputs.map(i=>i.dataset.group)));
    const prefix='radiator_filter_';
    const selected=()=>Object.fromEntries(groups.map(g=>[g,inputs.filter(i=>i.dataset.group===g&&i.checked).map(i=>i.value)]));
    const matches=(facts,state,except)=>groups.every(g=>g===except||!state[g].length||state[g].includes(facts[g]));
    function read(){const params=new URL(location.href).searchParams;inputs.forEach(i=>i.checked=(params.get(prefix+i.dataset.group)||'').split(',').includes(i.value));}
    function url(){const u=new URL(location.href);const state=selected();groups.forEach(g=>state[g].length?u.searchParams.set(prefix+g,state[g].join(',')):u.searchParams.delete(prefix+g));u.searchParams.delete('page');if(u.searchParams.has('sort_by'))u.searchParams.set('sort_by',u.searchParams.get('sort_by').replace(/\?+$/,''));return u;}
    const navigation=Array.from(document.querySelectorAll('#pf-pilot a.pf-sort,.woodmart-shop-tools a[data-page],.woodmart-shop-tools a[data-view]'));
    const targets=new Map(navigation.map(a=>[a,new URL(a.href)]));
    function apply(){const state=selected();let count=0;products.forEach(p=>{const match=matches(p.facts,state);if(match)count++;p.card.hidden=!match||count>visibleLimit;});
      if(more){more.hidden=count<=visibleLimit;more.classList.toggle('pf-hidden',more.hidden);}
      root.querySelector('.pf-results').textContent=data.countText.replace('__count__',count).replace('__total__',products.length);
      root.querySelector('.pf-empty').hidden=count!==0;const active=groups.some(g=>state[g].length);root.querySelector('.pf-clear').hidden=!active;root.querySelector('.pf-clear').classList.toggle('pf-hidden',!active);
      inputs.forEach(i=>{const n=products.filter(p=>matches(p.facts,state,i.dataset.group)&&p.facts[i.dataset.group]===i.value).length;i.disabled=!n&&!i.checked;i.closest('label').querySelector('.pf-count').textContent='('+n+')';});
      root.querySelectorAll('details[data-group]').forEach(d=>{const n=state[d.dataset.group].length;d.classList.toggle('pf-active',!!n);d.querySelector('.pf-selected').textContent=n?'('+n+') ':'';});
      navigation.forEach(a=>{const u=url(),target=targets.get(a);if(a.classList.contains('pf-sort'))u.searchParams.set('sort_by',target.searchParams.get('sort_by'));else u.searchParams.set('view',a.dataset.page||a.dataset.view);a.href=u.href;});
    }
    root.addEventListener('change',e=>{if(!e.target.matches('input[data-group]'))return;visibleLimit=pageSize;history.pushState(null,'',url());apply();});
    root.querySelector('.pf-clear').addEventListener('click',()=>{inputs.forEach(i=>i.checked=false);visibleLimit=pageSize;history.pushState(null,'',url());apply();});
    navigation.forEach(a=>a.addEventListener('click',e=>{if(e.button||e.ctrlKey||e.metaKey||e.shiftKey||e.altKey)return;e.preventDefault();e.stopImmediatePropagation();location.assign(a.href);},true));
    root.querySelectorAll('details').forEach(d=>d.addEventListener('toggle',()=>{if(d.open)root.querySelectorAll('details').forEach(other=>{if(other!==d)other.open=false;});}));
    document.addEventListener('click',e=>{if(!root.contains(e.target))root.querySelectorAll('details').forEach(d=>d.open=false);});
    root.addEventListener('keydown',e=>{if(e.key==='Escape'){root.querySelectorAll('details[open]').forEach(d=>{d.open=false;d.querySelector('summary').focus();});}});
    if(more)more.addEventListener('click',()=>{visibleLimit+=pageSize;apply();});
    window.addEventListener('popstate',()=>{visibleLimit=pageSize;read();apply();});read();apply();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pilot-mobile-product-facts"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => {
    document.querySelectorAll('.pilot-mobile-product-facts').forEach(target => {
      if (target.dataset.ready) return;
      const summary = target.closest('.entry-summary');
      if (!summary) return;
      const intro = summary.querySelector('.pilot-product-summary')?.closest('.shopify-product-details__short-description');
      const facts = summary.querySelector('.radiator-spec-strip');
      const nodes = [intro, facts].filter(Boolean);
      if (!nodes.length) return;
      target.dataset.ready = 'true';
      const origins = nodes.map(node => {
        const marker = document.createComment('');
        node.before(marker);
        return { node, marker };
      });
      const mobile = window.matchMedia('(max-width: 767px)');
      const position = () => {
        if (mobile.matches) {
          nodes.forEach(node => target.append(node));
          target.classList.add('is-active');
        } else {
          origins.forEach(({ node, marker }) => marker.after(node));
          target.classList.remove('is-active');
        }
      };
      position();
      mobile.addEventListener('change', position);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["save200-site-banner"] && !Shopify.designMode) return;
  try {
    function placeSave200Offer(){
  const link=document.querySelector('.save200-site-banner');
  const bar=document.querySelector('.announcement');
  if(!link||!bar)return;
  const phone=bar.querySelector('.announcement-phone');
  if(phone&&phone.parentElement===bar)bar.insertBefore(link,phone);
  else if(link.parentElement!==bar)bar.append(link);
  bar.classList.add('announcement--with-offer');
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',placeSave200Offer,{once:true});
else placeSave200Offer();
document.addEventListener('shopify:section:load',placeSave200Offer);
  } catch(e) { console.error(e); }
})();

})();
